import { AppConstants } from '@utils/app.constants';
import { DrillPointsParams, PersonalizeParams, RelatedReportParams } from '@services/index';
import { Observable, Subscriber, defer } from 'rxjs';
import { LMToolbarServiceAdapter } from './lm-toolbar-service-adapter';
import { map } from 'rxjs/operators';

/**
 * Created by ppatton on 1/4/2017.
 */
export class LMToolbarServiceBase {

  protected toolbarButtons: Array<LMToolbarButton> = new Array<LMToolbarButton>();
  protected toolbarButtonObserver: Subscriber<Array<LMToolbarButton>>;
  private toolbarButtonObservable: Observable<Array<LMToolbarButton>>;

  protected secondaryToolbarButtons: Array<LMToolbarButton> = new Array<LMToolbarButton>();
  protected secondaryToolbarButtonObserver: Subscriber<Array<LMToolbarButton>>;
  protected secondaryToolbarButtonIds: Array<string> = [];
  private secondaryToolbarButtonObservable: Observable<Array<LMToolbarButton>>;

  private AUDITVIEW_ACTIONS: Array<LMBusActionReference> = null;
  private STANDARD_TOOLBAR_ACTIONS: { [ key: string ]: LMBusActionReference } = null;
  private STANDARD_GALLERY_TOOLBAR_ACTIONS: { [ key: string ]: LMBusActionReference } = null;
  private STANDARD_ACTION_MENU_ITEMS: { [ key: string ]: LMBusActionReference } = null;
  private STANDARD_OPTIONS_MENU_ITEMS: { [ key: string ]: LMBusActionReference } = null;
  private STANDARD_SORT_MENU_ITEMS: Array<LMBusActionReference>;
  private STANDARD_SEPARATOR_MENU_ITEM: LMBusActionReference;
  private readonly testVersion1: boolean;

  constructor(public lmToolbarServiceAdapter: LMToolbarServiceAdapter) {
    if (!lmToolbarServiceAdapter.lmContextService) {
      // todo: ben for lm-form-toolbar.service.spec.ts and lm-list-toolbar.service.spec.ts tests failing.
      //  for some reason no lmContextService is set on the lmToolbarServiceAdapter at this time when these
      //  test consttruct this service.base.
      this.testVersion1 = true;
    } else {
      this.testVersion1 = lmToolbarServiceAdapter?.lmContextService?.testVersion() === AppConstants.TESTVERSION_V1;
    }
    this.toolbarButtonObservable = new Observable<Array<LMToolbarButton>>(observer => {
      this.toolbarButtonObserver = observer;
    });

    this.secondaryToolbarButtonObservable = new Observable<Array<LMToolbarButton>>(observer => {
      this.secondaryToolbarButtonObserver = observer;
    });
  }

  public getAuditViewActions(): Array<LMBusActionReference> {
    if (!this.AUDITVIEW_ACTIONS) {
      this.AUDITVIEW_ACTIONS = [
        { id: AppConstants.ACTION_TYPE_AUDIT_OVERRIDE,       automationId: AppConstants.ACTION_TYPE_AUDIT_OVERRIDE,       type: 'standard', label: Soho.Locale.translate('AuditCreate')        },
        { id: AppConstants.ACTION_TYPE_AUDIT_UPDATE,         automationId: AppConstants.ACTION_TYPE_AUDIT_UPDATE,         type: 'standard', label: Soho.Locale.translate('AuditUpdate')          },
        { id: AppConstants.ACTION_TYPE_CHANGE_EFFECTIVEDATE, automationId: AppConstants.ACTION_TYPE_CHANGE_EFFECTIVEDATE, type: 'standard', label: Soho.Locale.translate('ChangeEffectiveDate') },
        { id: AppConstants.ACTION_TYPE_AUDIT_DELETE,         automationId: AppConstants.ACTION_TYPE_AUDIT_DELETE,         type: 'standard', label: Soho.Locale.translate('AuditDelete')          },
      ];
    }
    return this.AUDITVIEW_ACTIONS;
  }
  public getStandardToolbarActions(): { [ key: string ]: LMBusActionReference } {
    if (!this.STANDARD_TOOLBAR_ACTIONS) {
      this.STANDARD_TOOLBAR_ACTIONS = {
        printToPDF:        { id: AppConstants.STANDARD_TOOLBAR_EXPORTPDF,             automationId: AppConstants.STANDARD_TOOLBAR_EXPORTPDF,             type: 'standard', tooltip: Soho.Locale.translate('PrintToFile'),   icon: 'pdf' },
        prevRecord:        { id: AppConstants.STANDARD_TOOLBAR_PREVRECORD,            automationId: AppConstants.STANDARD_TOOLBAR_PREVRECORD,            type: 'standard', tooltip: Soho.Locale.translate('Previous'),     icon: 'previous' }, //, label: Soho.Locale.translate('Previous')     },
        nextRecord:        { id: AppConstants.STANDARD_TOOLBAR_NEXTRECORD,            automationId: AppConstants.STANDARD_TOOLBAR_NEXTRECORD,            type: 'standard', tooltip: Soho.Locale.translate('Next'),         icon: 'next'     }, //, label: Soho.Locale.translate('Next')         },
        search:            { id: AppConstants.STANDARD_TOOLBAR_SEARCH,                automationId: AppConstants.STANDARD_TOOLBAR_SEARCH,                type: 'standard', tooltip: Soho.Locale.translate('Search'),       icon: 'filter'   }, //, label: Soho.Locale.translate('Search')       },
        create:            { id: AppConstants.STANDARD_TOOLBAR_CREATE,                automationId: AppConstants.STANDARD_TOOLBAR_CREATE,                type: 'standard', tooltip: Soho.Locale.translate('Create'),       icon: 'create'   }, //, label: Soho.Locale.translate('Create')       },
        inlineCreate:      { id: AppConstants.STANDARD_TOOLBAR_INLINECREATE,          automationId: AppConstants.STANDARD_TOOLBAR_INLINECREATE,          type: 'standard', tooltip: Soho.Locale.translate('InlineCreate'), icon: 'create'   }, //, label: Soho.Locale.translate('InlineCreate') },
        createMenu:        { id: AppConstants.STANDARD_TOOLBAR_CREATEMENU_BUTTON,     automationId: AppConstants.STANDARD_TOOLBAR_CREATEMENU_BUTTON,     type: 'standard', tooltip: Soho.Locale.translate('Create'),       icon: 'create'   }, //, label: Soho.Locale.translate('Create')       },
        open:              { id: AppConstants.STANDARD_TOOLBAR_OPEN,                  automationId: AppConstants.STANDARD_TOOLBAR_OPEN,                  type: 'standard', tooltip: Soho.Locale.translate('Open'),         icon: 'open'     }, //, label: Soho.Locale.translate('Open')         },
        save:              { id: AppConstants.STANDARD_SAVE,                          automationId: AppConstants.STANDARD_SAVE,                          type: 'standard', tooltip: Soho.Locale.translate('Save'),         icon: 'save'     }, //, label: Soho.Locale.translate('Save')         },
        saveAndNew:        { id: AppConstants.STANDARD_TOOLBAR_SAVENEW,               automationId: AppConstants.STANDARD_TOOLBAR_SAVENEW,               type: 'standard', tooltip: Soho.Locale.translate('SaveAndNew'),   icon: 'save-new' }, //, label: Soho.Locale.translate('SaveAndNew')   },
        matrixShowDetails: { id: AppConstants.STANDARD_TOOLBAR_MATRIXSHOWDETAIL,      automationId: AppConstants.STANDARD_TOOLBAR_MATRIXSHOWDETAIL,      type: 'standard', label:   Soho.Locale.translate('ShowDetails')                    },
        matrixHideDetails: { id: AppConstants.STANDARD_TOOLBAR_MATRIXHIDEDETAIL,      automationId: AppConstants.STANDARD_TOOLBAR_MATRIXHIDEDETAIL,      type: 'standard', label:   Soho.Locale.translate('HideDetails')                    },
        // Save As Draft - used by process flow
        saveAsDraft:       { id: AppConstants.STANDARD_TOOLBAR_SAVEASDRAFT,           automationId: AppConstants.STANDARD_TOOLBAR_SAVEASDRAFT,           type: 'standard', tooltip: Soho.Locale.translate('SaveAsDraft'),  icon: 'save', label: Soho.Locale.translate('SaveAsDraft'),      },
        pfCompare:         { id: AppConstants.STANDARD_TOOLBAR_PFCOMPARE,             automationId: AppConstants.STANDARD_TOOLBAR_PFCOMPARE,             type: 'standard', tooltip: Soho.Locale.translate('Compare'),       label: Soho.Locale.translate('Compare'),      },
        chartsMenu:        { id: AppConstants.STANDARD_TOOLBAR_CHARTMENU_BUTTON,      automationId: AppConstants.STANDARD_TOOLBAR_CHARTMENU_BUTTON,      type: 'standard', tooltip: Soho.Locale.translate('ChartOptions'),   icon: 'chart'   }, //, label: Soho.Locale.translate('ChartOptions')  },
        delete:            { id: AppConstants.STANDARD_TOOLBAR_DELETE,                automationId: AppConstants.STANDARD_TOOLBAR_DELETE,                type: 'standard', tooltip: Soho.Locale.translate('Delete'),         icon: 'delete'  }, //, label: Soho.Locale.translate('Delete')        },
        refresh:           { id: AppConstants.STANDARD_TOOLBAR_REFRESH,               automationId: AppConstants.STANDARD_TOOLBAR_REFRESH,               type: 'standard', tooltip: Soho.Locale.translate('Refresh'),        icon: 'refresh' }, //, label: Soho.Locale.translate('Refresh')       },
        sort:              { id: AppConstants.STANDARD_TOOLBAR_SORT,                  automationId: AppConstants.STANDARD_TOOLBAR_SORT,                  type: 'standard', tooltip: Soho.Locale.translate('ListSortLabel'),  icon: 'sort-ascending'  },
        actions:           { id: AppConstants.STANDARD_TOOLBAR_ACTIONSMENU_BUTTON,    automationId: AppConstants.STANDARD_TOOLBAR_ACTIONSMENU_BUTTON,    type: 'standard', label: Soho.Locale.translate('Actions') },
        allActionsMenu:    { id: AppConstants.STANDARD_TOOLBAR_ALLACTIONSMENU_BUTTON, automationId: AppConstants.STANDARD_TOOLBAR_ALLACTIONSMENU_BUTTON, type: 'standard', label: Soho.Locale.translate(AppConstants.STANDARD_TOOLBAR_ALLACTIONSMENU_BUTTON) },
        editMode:          { id: AppConstants.STANDARD_TOOLBAR_EDITMODE,              automationId: AppConstants.STANDARD_TOOLBAR_EDITMODE,              type: 'standard', label: Soho.Locale.translate('EditMode'),         icon: 'edit' },
        options:           { id: AppConstants.STANDARD_TOOLBAR_OPTIONSMENU_BUTTON,    automationId: AppConstants.STANDARD_TOOLBAR_OPTIONSMENU_BUTTON,    type: 'standard', label: Soho.Locale.translate('Options') },
        drillAroundMenu:   { id: AppConstants.STANDARD_TOOLBAR_RELATEDMENU_BUTTON,    automationId: AppConstants.STANDARD_TOOLBAR_RELATEDMENU_BUTTON,    type: 'standard', label: AppConstants.DRILL_AROUND_LABEL },
        // UserListView
        userListViewMenu:   { id: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MENU, automationId: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MENU, type: 'related', tooltip: Soho.Locale.translate('SavedSearchMenu'), icon: 'saved-search' },
        userListViewMoreMenu: { id: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MORE_MENU, automationId: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MORE_MENU, type: 'related', label: Soho.Locale.translate('More') },
      };
    }

    return this.STANDARD_TOOLBAR_ACTIONS;
  }

  public getGalleryToolbarActions(): { [ key: string ]: LMBusActionReference } {
    if (!this.STANDARD_GALLERY_TOOLBAR_ACTIONS) {
      this.STANDARD_GALLERY_TOOLBAR_ACTIONS = {
        prevRecord: { id: AppConstants.GALLERY_TOOLBAR_PREVIOUS, automationId: AppConstants.GALLERY_TOOLBAR_PREVIOUS, type: 'galleryPrevious', tooltip: Soho.Locale.translate('Previous'), icon: 'previous', skipDelay: true },
        nextRecord: { id: AppConstants.GALLERY_TOOLBAR_NEXT, automationId: AppConstants.GALLERY_TOOLBAR_NEXT, type: 'galleryNext', tooltip: Soho.Locale.translate('Next'), icon: 'next', skipDelay: true },
        viewAll:    { id: AppConstants.GALLERY_TOOLBAR_VIEW_ALL, automationId: AppConstants.GALLERY_TOOLBAR_VIEW_ALL, type: 'viewall', tooltip: Soho.Locale.translate('ViewAll')}
      };
    }

    return this.STANDARD_GALLERY_TOOLBAR_ACTIONS;
  }

  public getStandardActionMenuItems() {
    if (!this.STANDARD_ACTION_MENU_ITEMS) {
      this.STANDARD_ACTION_MENU_ITEMS = {
        open:          { id: AppConstants.STANDARD_TOOLBAR_OPEN,          automationId: AppConstants.STANDARD_TOOLBAR_OPEN,          type: 'standard', label: Soho.Locale.translate('Open'),         icon: 'open' },
        save:          { id: AppConstants.STANDARD_SAVE,                  automationId: AppConstants.STANDARD_SAVE,                  type: 'standard', label: Soho.Locale.translate('Save'),         icon: 'save' },
        saveAndNew:    { id: AppConstants.STANDARD_TOOLBAR_SAVENEW,       automationId: AppConstants.STANDARD_TOOLBAR_SAVENEW,       type: 'standard', label: Soho.Locale.translate('SaveAndNew'),   icon: 'save-new' },
        inlineCreate:  { id: AppConstants.STANDARD_TOOLBAR_INLINECREATE,  automationId: AppConstants.STANDARD_TOOLBAR_INLINECREATE,  type: 'standard', label: Soho.Locale.translate('InlineCreate'), icon: 'create' },
        createWithin:  { id: AppConstants.STANDARD_TOOLBAR_CREATEWITHIN,  automationId: AppConstants.STANDARD_TOOLBAR_CREATEWITHIN,  type: 'standard', label: Soho.Locale.translate('CreateWithin'), icon: 'create' },
        copyRow:       { id: AppConstants.STANDARD_TOOLBAR_COPYROW,       automationId: AppConstants.STANDARD_TOOLBAR_COPYROW,       type: 'standard', label: Soho.Locale.translate('CopyRow') },
        userListViewSave: { id: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVE, automationId: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVE, type: 'standard', label: Soho.Locale.translate('Save') },
        userListViewSaveAs: { id: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVEAS, automationId: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVEAS, type: 'standard', label: Soho.Locale.translate('SaveAs') },
        userListViewClear: { id: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_CLEAR, automationId: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_CLEAR, type: 'standard', label: Soho.Locale.translate('Clear') },
        userListViewManage: { id: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MANAGE, automationId: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MANAGE, type: 'standard', label: Soho.Locale.translate('Manage') },
        userListView:     { id: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW, automationId: AppConstants.STANDARD_TOOLBAR_USERLISTVIEW, type: 'standard' },
      };
    }

    return this.STANDARD_ACTION_MENU_ITEMS;
  }

  public getStandardOptionsMenuItems(): { [ key: string ]: LMBusActionReference } {
    if (!this.STANDARD_OPTIONS_MENU_ITEMS) {
      this.STANDARD_OPTIONS_MENU_ITEMS = {
        search:        { id: AppConstants.STANDARD_TOOLBAR_SEARCH,        automationId: AppConstants.STANDARD_TOOLBAR_SEARCH,        type: 'standard', label: Soho.Locale.translate('Search')       },
        printToFile:   { id: AppConstants.STANDARD_TOOLBAR_PRINTTOFILE,   automationId: AppConstants.STANDARD_TOOLBAR_PRINTTOFILE,   type: 'standard', label: Soho.Locale.translate('PrintToFile')  },
        printToPDF:    { id: AppConstants.STANDARD_TOOLBAR_EXPORTPDF,     automationId: AppConstants.STANDARD_TOOLBAR_EXPORTPDF,     type: 'standard', label: Soho.Locale.translate('PrintToPDF')   },
        exportToCSV:   { id: AppConstants.STANDARD_TOOLBAR_EXPORTCSV,     automationId: AppConstants.STANDARD_TOOLBAR_EXPORTCSV,     type: 'standard', label: Soho.Locale.translate('ExportToCSV')  },
        createReport:  { id: AppConstants.STANDARD_TOOLBAR_CREATEREPORT,  automationId: AppConstants.STANDARD_TOOLBAR_CREATEREPORT,  type: 'standard', label: Soho.Locale.translate('CreateReport') },
        relatedReport: { id: AppConstants.STANDARD_TOOLBAR_RELATEDREPORT, automationId: AppConstants.STANDARD_TOOLBAR_RELATEDREPORT, type: 'standard', label: Soho.Locale.translate('RelatedReport') },
        personalize:   { id: AppConstants.STANDARD_TOOLBAR_PERSONALIZE,   automationId: AppConstants.STANDARD_TOOLBAR_PERSONALIZE,   type: 'standard', label: Soho.Locale.translate('Personalize')  },
        refresh:       { id: AppConstants.STANDARD_TOOLBAR_REFRESH,       automationId: AppConstants.STANDARD_TOOLBAR_REFRESH,       type: 'standard', label: Soho.Locale.translate('Refresh')      },
        auditLog:      { id: AppConstants.STANDARD_TOOLBAR_VIEWAUDIT,     automationId: AppConstants.STANDARD_TOOLBAR_VIEWAUDIT,     type: 'standard', label: Soho.Locale.translate('ViewAuditLog') },
        fullAuditLog:  { id: AppConstants.STANDARD_TOOLBAR_VIEWFULLAUDIT, automationId: AppConstants.STANDARD_TOOLBAR_VIEWFULLAUDIT, type: 'standard', label: Soho.Locale.translate('ViewFullAuditLog') },
        auditCompare:  { id: AppConstants.STANDARD_TOOLBAR_AUDITCOMPARE,  automationId: AppConstants.STANDARD_TOOLBAR_AUDITCOMPARE,  type: 'standard', label: Soho.Locale.translate('AuditCompare') },
      };
    }
    return this.STANDARD_OPTIONS_MENU_ITEMS;
  }

  public getStandardSortMenuItems(elementIdPrefix: string): Array<LMBusActionReference> {
    const sortAscendingId = this.testVersion1 ? AppConstants.STANDARD_TOOLBAR_SORT_ORDER_ASCENDING : `${elementIdPrefix}_${AppConstants.STANDARD_TOOLBAR_SORT_ORDER_ASCENDING}`;
    const sortDescendingId = this.testVersion1 ? AppConstants.STANDARD_TOOLBAR_SORT_ORDER_DESCENDING : `${elementIdPrefix}_${AppConstants.STANDARD_TOOLBAR_SORT_ORDER_DESCENDING}`;

    if (!this.STANDARD_SORT_MENU_ITEMS) {
      this.STANDARD_SORT_MENU_ITEMS = [
        this.getStandardSeparatorMenuItem(),
        { id: AppConstants.STANDARD_TOOLBAR_SORT_ORDER_ASCENDING,  automationId: AppConstants.STANDARD_TOOLBAR_SORT_ORDER_ASCENDING,  elementId: sortAscendingId, type: 'standard', label: Soho.Locale.translate('SortAtoZ') },
        { id: AppConstants.STANDARD_TOOLBAR_SORT_ORDER_DESCENDING, automationId: AppConstants.STANDARD_TOOLBAR_SORT_ORDER_DESCENDING, elementId: sortDescendingId, type: 'standard', label: Soho.Locale.translate('SortZtoA') },
      ];
    }
    return this.STANDARD_SORT_MENU_ITEMS;
  }

  public getStandardSeparatorMenuItem(): LMBusActionReference {
    if (!this.STANDARD_SEPARATOR_MENU_ITEM){
      this.STANDARD_SEPARATOR_MENU_ITEM = { id: AppConstants.CSS_MENU_SEPARATOR, type: 'separator', label: '' };
    }
    return this.STANDARD_SEPARATOR_MENU_ITEM;
  }

  public getToolbarButtonsObservable(): Observable<Array<LMToolbarButton>> {
    return this.toolbarButtonObservable;
  }

  public getSecondaryToolbarButtonsObservable(): Observable<Array<LMToolbarButton>> {
    return this.secondaryToolbarButtonObservable;
  }

  public setSecondaryToolbarOptions(buttonIds: string[]): void {
    this.secondaryToolbarButtonIds = buttonIds;
  }

  public reset() {
    this.toolbarButtons = [];
    this.secondaryToolbarButtons = [];
    this.fireToolbarObservable();
    this.fireSecondaryToolbarObservable();
  }

  protected buildLMToolbarButton(spec: LMFormSpec | LMListSpec | LMPageSpec, actionReference: LMBusActionReference, visible: boolean, disabled: boolean, isMoreMenuItem: boolean): LMToolbarButton { // , menuType?: string, menu?: Array<any>
    this.updateActionIcon(spec, actionReference);
    const id = this.buildToolbarButtonId(spec, actionReference);
    const automationId = this.buildToolbarButtonAutomationId(spec, actionReference);
    const toolbarButton: LMToolbarButton = {
      id,
      automationId,
      actionReference,
      state:           { visible, disabled: disabled === false ? null : disabled },
      data:            JSON.stringify(actionReference),
      icon:            this.lmToolbarServiceAdapter.lmThemeService.lplIconToSohoXI(actionReference.icon),
      isToggle:        this.isToggleButton(actionReference),
      // menuType:        menuType,
      // menu:            menu
    };
    if (actionReference.isChecked) {
      toolbarButton.isChecked = true;
    }
    if (actionReference.hover) {
      // set the tooltip to the translated one from the server
      toolbarButton.actionReference.tooltip = actionReference.hover;
    }
    if (isMoreMenuItem) {
      toolbarButton.isMoreMenuItem = isMoreMenuItem;
    }
    if (actionReference.icon && !actionReference.label) {
      toolbarButton.isIconOnly = true;
      // todo move these to the server so that the client doesn't have to massage these values
      if (!actionReference.hover ) {
        this.setDefaultHoverText(spec, actionReference, toolbarButton);
      }
    }
    return toolbarButton;
  }

  protected buildActionReference(actionSpec: LMActionSpec) {
    const actionReference: LMBusActionReference = {
      id: actionSpec.name,
      type: 'standard',
    };
    if (actionSpec.type === 'UPDATE'
      ||  actionSpec.type === 'DELETE'
      ||  actionSpec.type === 'CREATE'
      ||  actionSpec.type === 'CREATE_WITHIN'
      ||  actionSpec.type === 'FUNCTION'
      ||  actionSpec.type === 'SET'
      ||  actionSpec.type === 'AUDIT_DELETE'
      ||  actionSpec.type === 'CHANGE_EFFECTIVEDATE') {
      actionReference.type = 'action';
      actionReference.index = actionSpec.index;
    }

    return actionReference;
  }

  protected buildDrillActionReferences(drillAction: LMDrillAction) {
    const actionReference: LMBusActionReference = {
      id: drillAction.drillId,
      automationId:  drillAction.drillId,
      label: drillAction.drillName,
      relActionUrl: drillAction.drillUrl,
      isDrillAround: true,
      type: 'related'
    };
    return actionReference;
  }

  protected buildRelatedReportReferences(lmRelatedReportAction: LMRelatedReportAction) {
    const actionReference: LMBusActionReference = {
      id: AppConstants.STANDARD_TOOLBAR_RELATEDREPORT,
      automationId: AppConstants.STANDARD_TOOLBAR_RELATEDREPORT,
      label: lmRelatedReportAction.reportName,
      relActionUrl: lmRelatedReportAction.reportUrl,
      type: 'standard'
    };
    return actionReference;
  }

  protected buildPersonalizeReferences(lmPersonalizeAction: LMPersonalizeAction, actionUrl?: string) {
    const actionReference: LMBusActionReference = {
      id: lmPersonalizeAction.name,
      automationId: lmPersonalizeAction.name,
      label: lmPersonalizeAction.label,
      type: 'personalize',
      relActionUrl: actionUrl
    };

    // if (actionUrl) {
    //   const compiledUrlTemplate = urltemplate.parse(actionUrl);
    //   actionReference.relActionUrl = compiledUrlTemplate.expand({ resourceId: resourceId });
    // }
    return actionReference;
  }

  protected buildUserListViewReferences(userListView: LMUserListViewItem, isChecked: boolean) {
    const actionReference = {
      ...(this.getStandardActionMenuItems().userListView),
      label: userListView.name,
      userListViewItem: userListView,
      searchState: JSON.parse(userListView.searchState),
      isChecked
    };
    return actionReference;
  }

  protected buildPfActionReference(pfAction: LMProcessFlowAction) {
    let iconName: LMIcon = 'process';
    if (pfAction.name.toLowerCase() === 'approve') {
      iconName = <LMIcon> 'approve';
    } else if (pfAction.name.toLowerCase() === 'acknowledge') {
      iconName = <LMIcon> 'submit';
    } else if (pfAction.name.toLowerCase() === 'reject') {
      iconName = <LMIcon> 'reject';
    } else if (pfAction.name.toLowerCase() ===  'return') {
      iconName = <LMIcon> 'undo';
    }

    const actionReference: LMBusActionReference = {
      id: pfAction.name,
      label: pfAction.label,
      type: 'processflow',
      icon: iconName,
    };
    return actionReference;
  }

  protected actionSpecsToActionRefs(actionSpecs: Array<LMActionSpec>, dataView?: LMDataView): Array<LMBusActionReference> {
    return actionSpecs.map(actionSpec => {
      let label = actionSpec.label;
      if (dataView && dataView.actionMeta) {
        const actionMeta = dataView.actionMeta[actionSpec.name];
        if (actionMeta) {
          label = actionMeta.actionLabel;
        }
      }
      return <LMBusActionReference> {
        id: actionSpec.name,
        automationId: actionSpec.name,
        label,
        type: 'action',
        index: actionSpec.index
      };
    });
  }

  private isToggleButton(actionReference: LMBusActionReference): boolean {
    switch (actionReference.type) {
      case 'standard':
        return actionReference.id === AppConstants.STANDARD_TOOLBAR_SEARCH;

      case 'action':
      case 'related':
      case 'navigation':
      case 'helperList':
      default:
        return false;
    }
  }

  protected includeActionRef(spec: LMFormSpec | LMListSpec, actionReference: LMBusActionReference, listStateInfo?: LMListStateInfo): boolean {
    return true;
  }

  protected actionRefArrayToToolbarButtonArray(spec: LMFormSpec | LMListSpec, actionRefArray: Array<LMBusActionReference>, isMoreMenuItem = false, listStateInfo?: LMListStateInfo): Array<LMToolbarButton> {
    return actionRefArray
      .filter(actionRef => this.includeActionRef(spec, actionRef, listStateInfo))
      .map(actionRef => this.buildLMToolbarButton(spec, actionRef, false, true, isMoreMenuItem));
  }

  public drillActionsToActionRefArray(drillActions: Array<LMDrillAction>): Array<LMBusActionReference> {
    return drillActions.map(drillAction => this.buildDrillActionReferences(drillAction));
  }

  protected pfActionsToActionRefArray(pfActions: Array<LMProcessFlowAction>): Array<LMBusActionReference> {
    return pfActions.map(pfAction => this.buildPfActionReference(pfAction));
  }

  private relatedReportsToActionRefArray(lmRelatedReportActions: Array<LMRelatedReportAction>): Array<LMBusActionReference> {
    return lmRelatedReportActions.map(lmRelatedReportAction => this.buildRelatedReportReferences(lmRelatedReportAction));
  }

  private personalizeToActionRefArray(lmPersonalizeActions: Array<LMPersonalizeAction>, actionUrl?: string): Array<LMBusActionReference> {
    return lmPersonalizeActions.map(lmPersonalizeAction => this.buildPersonalizeReferences(lmPersonalizeAction, actionUrl));
  }

  private userListViewsToActionRefArray(lmUserListViews: LMUserListViewItem[], appliedUserListView?: string): Array<LMBusActionReference> {
    return lmUserListViews.map(lmUserListView => this.buildUserListViewReferences(lmUserListView, lmUserListView.userListView === appliedUserListView));
  }

  protected hasCreateMenu(actionReferences: Array<LMBusActionReference>): boolean {
    let hasCreateMenu = false;
    if (actionReferences?.length > 0) {
      const createMenuActionRef = actionReferences.find(actionRef => actionRef.id === AppConstants.STANDARD_TOOLBAR_CREATEMENU_BUTTON);
      hasCreateMenu = !!createMenuActionRef;
    }

    return hasCreateMenu;
  }

  protected actionSpecsToActionRefsSorted(actionSpecs: Array<LMActionSpec>): Array<LMBusActionReference> {
    const actionRefs: Array<LMBusActionReference> = this.actionSpecsToActionRefs(actionSpecs);
    actionRefs.sort((actionRef1: LMBusActionReference, actionRef2: LMBusActionReference) => actionRef1.label.localeCompare(actionRef2.label));

    return actionRefs;
  }

  public createToolbarMenuItemsFromActionReferences(
    spec: LMFormSpec | LMListSpec | LMPageSpec,
    actionReferences: Array<LMBusActionReference>,
    isMoreMenuItem = false
  ): Array<LMToolbarButton> {
    return actionReferences.map(actionReference => this.buildLMToolbarButton(spec, actionReference, true, false, isMoreMenuItem));
  }

  protected fireToolbarObservable() {
    // ---------------------------------------------------------------------
    // Return a copy of the toolbar buttons array so change detection
    // works for the banner toolbar.
    // ---------------------------------------------------------------------
    if (this.toolbarButtonObserver) {
      this.toolbarButtonObserver.next([ ...this.toolbarButtons ]);
    }
  }

  protected fireSecondaryToolbarObservable() {
    // ---------------------------------------------------------------------
    // Return a copy of the secondary toolbar buttons array so change
    // detection works for the banner toolbar.
    // ---------------------------------------------------------------------
    if (this.secondaryToolbarButtonObserver) {
      this.secondaryToolbarButtonObserver.next([ ...this.secondaryToolbarButtons ]);
    }
  }

  public buildMoreButtonMenu(
    spec: LMFormSpec | LMListSpec | LMPageSpec,
    response: SohoPopupMenuResponseFunction,
    options: any,
    buttons: Array<LMToolbarButton>,
    moreButtonParams: LMToolbarMoreButtonMenuParams,
    relatedActionsFunction?: (response: AjaxBeforeOpenResponseFunction, options: any) => void
  ): void {
    if (options.hasOwnProperty('contextElement') && options.contextElement.length > 0) {
      let id = options.contextElement[0].id;
      let sourceFlexToolbarButtonId = '';

      // if (id === '' && options.isSubmenu) {
      // check for undefined, null, or ''
      if (!id && options.isSubmenu) {
        // overflowed button is a menu button. Need to step up the dom to get the correct id
        const idArray = options.contextElement[0].parentElement.previousElementSibling.id.split('-');
        id = idArray[idArray.length - 1];
        sourceFlexToolbarButtonId = id;

        const toolbarButtonElement = document.getElementById(id);
        id = JSON.parse(toolbarButtonElement.dataset.actionReference).id;
      }

      if (id === AppConstants.STANDARD_TOOLBAR_RELATEDMENU_BUTTON) {
        if (moreButtonParams.showDrillAround) {
          // build drill around menu
          defer(async () => await this.lmToolbarServiceAdapter.lmDrillService.getDrillPoints(moreButtonParams.drillParams).toPromise())
            .subscribe((drillPoints: Array<LMDrillAction>) => {
              let menuResponse = '';
              if (drillPoints.length > 0) {
                const actionRefs: Array<LMBusActionReference> = this.drillActionsToActionRefArray(drillPoints);

                const subMenuButtons: Array<LMToolbarButton> = this.createToolbarMenuItemsFromActionReferences(spec, actionRefs);
                for (let index = 0; subMenuButtons.length > index; index++) {
                  const menuItem: LMToolbarButton = subMenuButtons[ index ];
                  if (menuItem.state.visible) {
                    const classes = (menuItem.state.disabled ? 'is-disabled' : '') + ' ' + (menuItem.isChecked ? 'is-checked' : '');
                    menuResponse += this.createMenuResponse(spec, 'related', classes, menuItem);
                  }
                }
              } else {
                const noActionMenu: LMToolbarButton = {
                  actionReference: { id: 'noop', type: 'noop', label: Soho.Locale.translate('NoDrillsAvailable') },
                  state:           { disabled: false, visible: true }
                };
                const classes = noActionMenu.state.disabled ? 'is-disabled' : '';
                menuResponse += this.createMenuResponse(spec, noActionMenu.actionReference.id, classes, noActionMenu);
              }
              response(menuResponse);
            });
        } else {
          let menuResponse = '';
          const noActionMenu: LMToolbarButton = {
            actionReference: { id: 'noop', type: 'noop', label: Soho.Locale.translate('NoDrillsAvailable') },
            state:           { disabled: false, visible: true }
          };
          const classes = noActionMenu.state.disabled ? 'is-disabled' : '';
          menuResponse += this.createMenuResponse(spec, noActionMenu.actionReference.id, classes, noActionMenu);

          response(menuResponse);
        }
      } else if (id === AppConstants.STANDARD_TOOLBAR_RELATEDREPORT) {
        this.lmToolbarServiceAdapter.lmRelatedReportService.getRelatedReports(moreButtonParams.relatedReportParams.sourceResourceUrl)
          .subscribe((reports: LMRelatedReports) => {
            let menuResponse = '';
            const lmRelatedReportActions = reports.relatedReports;

            if (lmRelatedReportActions.length > 0) {
              const actionRefs: Array<LMBusActionReference> = this.relatedReportsToActionRefArray(lmRelatedReportActions);

              // Add more reports link
              if (reports.moreReportsUrl) {
                actionRefs.push({
                  id: AppConstants.STANDARD_TOOLBAR_RELATEDREPORT_MORE,
                  label: Soho.Locale.translate('MoreReports'),
                  relActionUrl: `${reports.moreReportsUrl}&reportListTitle=${moreButtonParams.relatedReportParams.listTitle}`,
                  type: 'standard'
                });
              }

              const subMenuButtons: Array<LMToolbarButton> = this.createToolbarMenuItemsFromActionReferences(spec, actionRefs);
              for (let index = 0; subMenuButtons.length > index; index++) {
                const menuItem: LMToolbarButton = subMenuButtons[index];
                if (menuItem.state.visible) {
                  const classes = (menuItem.state.disabled ? 'is-disabled' : '') + ' ' + (menuItem.isChecked ? 'is-checked': '');
                  menuResponse += this.createMenuResponse(spec, menuItem.id, classes, menuItem);
                }
              }
            } else {
              const noActionMenu: LMToolbarButton = {
                actionReference: {
                  id: 'noop',
                  type: 'noop',
                  label: Soho.Locale.translate('NoRelatedReportAvailable')
                },
                state: { disabled: false, visible: true }
              };
              const classes = noActionMenu.state.disabled ? 'is-disabled' : '';
              menuResponse += this.createMenuResponse(spec, noActionMenu.actionReference.id, classes, noActionMenu);
            }
            response(menuResponse);
          });
      } else if (id === AppConstants.STANDARD_TOOLBAR_PERSONALIZE) {
        const userFolder: string = (spec as LMListSpec).userFolder;

        this.lmToolbarServiceAdapter.lmConfigurationService.getPersonalization(moreButtonParams.personalizeParams.sourceResourceUrl, userFolder)
          .subscribe((lmPersonalizeResponse: LMPersonalizeResponse) => {
            const lmPersonalizeActions = lmPersonalizeResponse.actions;
            const actionUrl = lmPersonalizeResponse.actionUrl;
            // let resourceId = lmPersonalizeResponse.resourceId;
            let menuResponse = '';
            const actionRefs: Array<LMBusActionReference> = this.personalizeToActionRefArray(lmPersonalizeActions, actionUrl);

            const subMenuButtons: Array<LMToolbarButton> = this.createToolbarMenuItemsFromActionReferences(spec, actionRefs);
            for (let index = 0; subMenuButtons.length > index; index++) {
              const menuItem: LMToolbarButton = subMenuButtons[index];
              if (menuItem.state.visible) {
                const classes = (menuItem.state.disabled ? 'is-disabled' : '') + ' ' + (menuItem.isChecked ? 'is-checked': '');
                menuResponse += this.createMenuResponse(spec, 'related', classes, menuItem);
              }
            }
            response(menuResponse);
          });
      } else if (id === AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MENU || id === AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MORE_MENU) {
        this.userListViewMoreMenuResponse(id, options, spec, moreButtonParams).subscribe((menuResponse: string) => response(menuResponse));
      } else {
        let menuResponse = '';
        const parentButton = buttons.find(button => button.actionReference.id === id);
        if (!!parentButton) {
          for (const button of parentButton.menu) {
            if (button.actionReference.type === AppConstants.CSS_MENU_SEPARATOR) {
              menuResponse += `
            <li class='separator'></li>`;
              continue;
            }
            if (button.state.visible) {
              if (button.menu) {
                const actionRef = this.stringifyJson(button.actionReference);
                menuResponse +=
                  `<li id="${this.menuIdV1(button.actionReference.id)}" class="submenu">
                    <a
                        id="${this.menuIdV2(button.actionReference.id)}"
                        data-automation-id="lm-${button.automationId}-toolbar-menuitem"
                        attr.data-action-reference='${actionRef}'>${button.actionReference.label}</a>
                      <ul class="popupmenu" id="${button.actionReference.id}" data-original-menu="${button.actionReference.id}"></ul>
                  </li>`;
              } else {
                const classes = (button.state.disabled ? 'is-disabled' : '') + ' ' + (button.isChecked ? 'is-checked' : '');
                menuResponse += this.createMenuResponse(spec, button.id, classes, button);
              }
            }
          }
          response(menuResponse);
        } else {
          let actionRefData = options.contextElement[0].getAttribute('data-action-reference');
          // Alternatively, get action reference from its source flex button from the toolbar
          if (!actionRefData && id) {
            if (document.querySelector(`${id}`)) {
              actionRefData = document.querySelector(`#${id}`)
                .getAttribute('data-action-reference');
            } else {
              actionRefData = document.querySelector(`#${sourceFlexToolbarButtonId}`)
                .getAttribute('data-action-reference');
            }
          }
          const actionRef = JSON.parse(actionRefData) as LMBusActionReference;
          // Logic derived from LMToolbarComponent:onBeforeRelatedActionsOpen calling
          // LMDynamicToolbarService:getRelatedActionMenuItems and use response to build the submenu.
          // TODO: Consider converting this class into a servicea and merge it with LMDynamicToolbarService
          // todo: we have to chagne this so http is not called directly. This should be called from
          //  SpecUtilService and be converted to the new spec url functionality.
          this.lmToolbarServiceAdapter.http.get(actionRef.relActionUrl)
            .pipe(
              map((relActionResponse: RelatedActionResponse) => {
                const actionSpec = relActionResponse.actionSpec;
                return relActionResponse.dataViewSet.data.map((dataView: LMDataView, index: number) =>
                  this.buildToolbarRelatedActionMenuEntry(
                    spec,
                    {
                      id: `${actionSpec.name}_popup${index}`,
                      type: 'related',
                      index: actionSpec.index,
                      label: actionSpec.label,
                      requestAction: actionSpec.requestAction,
                      resourceId: dataView.resourceId
                    } as LMBusActionReference,
                    actionSpec,
                    dataView.representativeText
                  )
                );
              })
            ).subscribe((menuEntries: string[]) => {
              if (menuEntries.length === 0) {
                response(`<li><a href="#">${Soho.Locale.translate('NoItemsAvailable')}</a></li>`);
              } else {
                response(menuEntries.join(''));
              }
            });
        }
      }
    } else if (moreButtonParams.isContextMenu) {
      const initialResponse = this.buildFirstLevelMoreMenu(spec, buttons, moreButtonParams.showDrillAround);
      response(initialResponse);
    }
  }

  private userListViewMoreMenuResponse(id: string, options: any, spec: LMFormSpec | LMListSpec | LMPageSpec, moreButtonParams: LMToolbarMoreButtonMenuParams): Observable<string> {
    return new Observable(observer => {
      let lk;
      if (id === AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MORE_MENU) {
        let submenuElem = options.contextElement[0].previousElementSibling as HTMLElement;
        if (!submenuElem) {
          submenuElem = options.contextElement[0].parentElement.previousElementSibling;
        }
        const actionRef = JSON.parse(submenuElem.dataset.actionReference) as LMBusActionReference;
        lk = actionRef.lk;
      }
      this.lmToolbarServiceAdapter.lmConfigurationService.fetchUserListViews(moreButtonParams.userListViewParams.userListViewUrl, lk).subscribe((result: LMUserListViewResponse) => {
        let menuResponse = '';
        const actionRefs: Array<LMBusActionReference> = this.userListViewsToActionRefArray(result.savedViews, moreButtonParams.userListViewParams.appliedUserListView);

        const subMenuButtons: Array<LMToolbarButton> = this.createToolbarMenuItemsFromActionReferences(spec, actionRefs);
        for (let index = 0; subMenuButtons.length > index; index++) {
          const menuItem: LMToolbarButton = subMenuButtons[index];
          if (menuItem.state.visible) {
            const classes = (menuItem.state.disabled ? 'is-disabled' : '') + ' ' + (menuItem.isChecked ? 'is-checked': '');
            menuResponse += this.createMenuResponse(spec, 'related', classes, menuItem);
          }
        }
        if (result.hasMore) {
          const moreActionRef = { ...this.getStandardToolbarActions().userListViewMoreMenu,
            lk: result.lk,
            isSubMenu: true,
            userListViewUrl: moreButtonParams.userListViewParams.userListViewUrl,
            appliedUserListView: moreButtonParams.userListViewParams.appliedUserListView,
            disableSave: moreButtonParams.userListViewParams.disableSave
          };
          const moreItem = this.buildLMToolbarButton(spec, moreActionRef, true, false, false);
          menuResponse += this.buildSubMenuItemLiFromButton(spec, moreItem);
        }

        if (id === AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MENU) {
          if (subMenuButtons.length > 0) {
            menuResponse += `<li class='separator'></li>`;
          }
          const saveItem = this.buildLMToolbarButton(spec, this.getStandardActionMenuItems().userListViewSave, true, moreButtonParams.userListViewParams.disableSave, false);
          const saveClasses = (saveItem.state.disabled ? 'is-disabled' : '') + ' ' + (saveItem.isChecked ? 'is-checked' : '');
          menuResponse += this.createMenuResponse(spec, AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVE, saveClasses, saveItem);

          const saveAsItem = this.buildLMToolbarButton(spec, this.getStandardActionMenuItems().userListViewSaveAs, true, moreButtonParams.userListViewParams.disableSave, false);
          const saveAsClasses = (saveAsItem.state.disabled ? 'is-disabled' : '') + ' ' + (saveAsItem.isChecked ? 'is-checked' : '');
          menuResponse += this.createMenuResponse(spec, AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVE, saveAsClasses, saveAsItem);

          menuResponse += `<li class='separator'></li>`;
          const clearItem = this.buildLMToolbarButton(spec, this.getStandardActionMenuItems().userListViewClear, true, moreButtonParams.userListViewParams.appliedUserListView === undefined, false);
          const clearClasses = (clearItem.state.disabled ? 'is-disabled' : '') + ' ' + (clearItem.isChecked ? 'is-checked' : '');
          menuResponse += this.createMenuResponse(spec, AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_CLEAR, clearClasses, clearItem);

          const manageItem = this.buildLMToolbarButton(spec, this.getStandardActionMenuItems().userListViewManage, true, result.savedViews?.length === 0, false);
          const manageClasses = (manageItem.state.disabled ? 'is-disabled' : '') + ' ' + (manageItem.isChecked ? 'is-checked' : '');
          menuResponse += this.createMenuResponse(spec, AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_CLEAR, manageClasses, manageItem);
        }
        observer.next(menuResponse);
        observer.complete();
      });
    });
  }

  private buildToolbarRelatedActionMenuEntry(
    spec: LMFormSpec | LMListSpec | LMPageSpec,
    actionReference: LMBusActionReference,
    actionSpec: LMActionSpec,
    title: string
  ): string {
    const markup =
      `<li id='${this.menuIdV1(actionReference.resourceId)}'>
        <a id='${this.menuIdV2(actionReference.resourceId)}'
            data-automation-id="lm-${this.buildToolbarButtonAutomationId(spec, actionReference)}-toolbar-menuitem"
            href="#" data-action-reference='${this.stringifyJson(actionReference)}'
            data-action-spec='${this.stringifyJson(actionSpec)}'>${title}</a>
      </li>`;
    return markup;
  }

  // NOTE refactored below on 7/1/2020 by ppatton - remove once it's all tested and working.
  // public buildFirstLevelMoreMenu(buttons: Array<LMToolbarButton>,showDrillAround: boolean): string {
  //   const initialResponse = '';
  //   for (let index = 0; buttons.length > index; index++) {
  //     const menuItem = buttons[ index ];
  //     if (menuItem.state.visible) {
  //       const label = menuItem.actionReference.label ? menuItem.actionReference.label : menuItem.actionReference.tooltip;
  //       if (menuItem.menu) {
  //         if (this.submenuHasVisibleItems(menuItem.menu)) {
  //           if (menuItem.actionReference.id === AppConstants.STANDARD_TOOLBAR_RELATEDMENU_BUTTON && !showDrillAround) {
  //             continue;
  //           }
  //           const actionRef = this.stringifyJson(menuItem.actionReference);
  //           initialResponse +=
  //             `<li class="submenu">
  //                 <a attr.data-action-reference='${actionRef}'>${label}</a>
  //                 <ul class="popupmenu" id="${menuItem.actionReference.id}"></ul>
  //               </li>`;
  //         }
  //       } else {
  //         const classes = menuItem.state.disabled ? 'is-disabled' : '';
  //         const actionRef = this.stringifyJson(menuItem.actionReference);
  //
  //         if (menuItem.actionReference.type === AppConstants.CSS_MENU_SEPARATOR) {
  //           // to add a header title after the separator, add <li class='heading'>Button Header Here</li> here
  //           initialResponse += `<li class='separator'></li>`;
  //         } else {
  //           initialResponse += `
  //             <li class="${classes}">
  //               <a id="${menuItem.actionReference.id}" attr.data-action-reference='${actionRef}' data-action-reference='${actionRef}'>${label}</a>
  //             </li>`;
  //         }
  //       }
  //     }
  //   }
  //   return initialResponse;
  // }

  public buildFirstLevelMoreMenu(
    spec: LMFormSpec | LMListSpec | LMPageSpec,
    buttons: Array<LMToolbarButton>,
    showDrillAround: boolean
  ): string {
    let firstLevelMoreMenuMarkup = '';
    buttons.filter(button => this.includeInFirstLevelMoreMenu(button, showDrillAround)).forEach(button => {
      firstLevelMoreMenuMarkup += this.buildFirstLevelMoreMenuItem(spec, button);
    });
    return firstLevelMoreMenuMarkup;
  }

  private includeInFirstLevelMoreMenu(button: LMToolbarButton, showDrillAround: boolean): boolean {
    // --------------------------------------------------------
    // if it's not visible then don't include the li markup
    // --------------------------------------------------------
    if (!button.state.visible) {
      return false;
    }

    if (button.menu) {
      // --------------------------------------------------------
      // if the submenu has no visible menu items then don't
      // include the submenu item markup
      // --------------------------------------------------------
      if (!this.submenuHasVisibleItems(button.menu)) {
        return false;
      }

      // --------------------------------------------------------
      // if showDrillAround is false then don't include the
      // DrillAround submenu item markup
      // --------------------------------------------------------
      if (button.actionReference.id === AppConstants.STANDARD_TOOLBAR_RELATEDMENU_BUTTON && !showDrillAround) {
        return false;
      }
    }

    return true;
  }

  private buildFirstLevelMoreMenuItem(spec: LMFormSpec | LMListSpec | LMPageSpec, button: LMToolbarButton): string {
    if (button.menu) {
      return this.buildSubMenuItemLiFromButton(spec, button);
    }

    if (button.actionReference.type === AppConstants.CSS_MENU_SEPARATOR) {
      // to add a header title after the separator, add <li class='heading'>Button Header Here</li> here
      return `<li class='separator'></li>`;
    }

    return this.buildMenuItemLiFromButton(spec, button);
  }

  private buildMenuItemLiFromButton(spec: LMFormSpec | LMListSpec | LMPageSpec, button: LMToolbarButton): string {
    const label = button.actionReference.label ? button.actionReference.label : button.actionReference.tooltip;
    const classes = (button.state.disabled ? 'is-disabled' : '') + ' ' + (button.isChecked ? 'is-checked' : '');
    const actionRef = this.stringifyJson(button.actionReference);

    const markup =
      `<li id="${this.menuIdV1(button.actionReference.id)}" class="${classes}">
        <a id="${this.menuIdV2(button.actionReference.id)}"
            data-automation-id="lm-${button.automationId}-toolbar-menuitem"
            attr.data-action-reference='${actionRef}'
            data-action-reference='${actionRef}'>${label}</a>
      </li>`;
    return markup;

  }

  private buildSubMenuItemLiFromButton(spec: LMFormSpec | LMListSpec | LMPageSpec, button: LMToolbarButton): string {
    const label = button.actionReference.label ? button.actionReference.label : button.actionReference.tooltip;
    const actionRef = this.stringifyJson(button.actionReference);
    const markup =
      `<li id="${this.menuIdV1(button.actionReference.id)}" class="submenu">
        <a id="${this.menuIdV2(button.actionReference.id)}"
            data-automation-id="lm-${button.automationId}-toolbar-menuitem"
            attr.data-action-reference='${actionRef}'
            data-action-reference='${actionRef}'>${label}</a>

        <!-- do not change the id for this ul.popupmenu. The id used as a mechanism to find
             the correct menu to build in LMToolbarServiceBase.buildMoreButtonMenu().
         -->
        <ul class="popupmenu" id="${button.actionReference.id}"></ul>
      </li>`;
    return markup;
  }

  private createMenuResponse(spec: LMFormSpec | LMListSpec | LMPageSpec, id: string, classes: string, menuItem: LMToolbarButton): string {
    const actionRef = this.stringifyJson(menuItem.actionReference);
    const markup =
      `<li id="${this.menuIdV1(id)}" class="${classes}">
        <a id="${this.menuIdV2(id)}"
            data-automation-id="lm-${menuItem.automationId}-toolbar-menuitem"
            attr.data-action-reference='${actionRef}'
            data-action-reference='${actionRef}'>${menuItem.actionReference.label}</a>
      </li>`;
    return markup;
  }

  private submenuHasVisibleItems(menu: Array<LMToolbarButton>): boolean {
    let hasVisibleItem = false;
    for (const button of menu) {
      if (button.state.visible) {
        hasVisibleItem = true;
        break;
      }
    }
    return hasVisibleItem;
  }

  private stringifyJson(actionReference: any) {
    const actionReferenceClone = JSON.parse(JSON.stringify(actionReference));
    if (actionReferenceClone.label && actionReferenceClone.label.search(/'/g) > -1) {
      // html encode single quotes as they screw up when placed into a element.dataset.
      actionReferenceClone.label = actionReferenceClone.label.replace(/'/g, (substring, ...args) => '&#39;');
    }

    return JSON.stringify(actionReferenceClone);
  }

  protected buildToolbarButtonId(spec: LMFormSpec | LMListSpec | LMPageSpec, actionReference: LMBusActionReference): string {
    if (actionReference.elementId) {
      // if using elementId it should already be prefixed.
      return actionReference.elementId;
    }

    return this.getButtonIdPrefix(spec) + '_' + actionReference.id;
  }

  protected buildToolbarButtonAutomationId(spec: LMFormSpec | LMListSpec | LMPageSpec, actionReference: LMBusActionReference): string {
    return this.getButtonAutomationIdPrefix(spec) + '-' + actionReference.automationId;
  }

  private getButtonAutomationIdPrefix(spec: LMListSpec | LMFormSpec) {
    if (!spec) {
      return '';
    }

    if ((spec as LMListSpec).busListSpec) {
      return (spec as LMListSpec).busListSpec.automationId;
    }

    if ((spec as LMFormSpec).busFormSpec) {
      return (spec as LMFormSpec).busFormSpec.name;
    }

    if ((spec as LMPageSpec).pageSpec) {
      return (spec as LMPageSpec).pageSpec.name;
    }

    return '';
  }

  private getButtonIdPrefix(spec: LMListSpec | LMFormSpec) {
    if (!spec) {
      return '';
    }

    if ((spec as LMListSpec).busListSpec) {
      return (spec as LMListSpec).busListSpec.id;
    }

    if ((spec as LMFormSpec).busFormSpec) {
      return (spec as LMFormSpec).busFormSpec.name;
    }

    if ((spec as LMPageSpec).pageSpec) {
      return (spec as LMPageSpec).pageSpec.name;
    }

    return '';
  }

  private menuIdV1(id: string): string {
    return this.lmToolbarServiceAdapter.lmContextService.testVersion() === AppConstants.TESTVERSION_V1 ? id : '';
  }

  private menuIdV2(id: string): string {
    return this.lmToolbarServiceAdapter.lmContextService.testVersion() >= AppConstants.TESTVERSION_V2 ? id + '_menuitem' : '';
  }

  private getActionSpecs(spec: LMFormSpec | LMListSpec | LMPageSpec): Array<LMActionSpec> {
    if (!spec) {
      return [];
    }
    if ((spec as LMListSpec).busListSpec) {
      return (spec as LMListSpec).busClassSpec.actions;
    }
    if ((spec as LMFormSpec).busFormSpec) {
      return (spec as LMFormSpec).busClassSpec.actions;
    }
    return [];
  }

  private updateActionIcon(spec: LMFormSpec | LMListSpec | LMPageSpec, actionReference: LMBusActionReference) {
    try {
      if (actionReference.type === 'action' && !actionReference.icon && !actionReference.label) {
        const actionSpecArray: Array<LMActionSpec> = this.getActionSpecs(spec);
        if (!actionSpecArray || actionSpecArray.length === 0) {
          return;
        }
        const actionSpec: LMActionSpec = actionSpecArray[actionReference.index];
        if (!actionSpec || !actionSpec.type) {
          return;
        }
        switch (actionSpec.type) {
          case 'CREATE':
            actionReference.icon = 'create';
            break;
          case 'UPDATE':
            actionReference.icon = 'open';
            break;
          case 'DELETE':
            actionReference.icon = 'delete';
            break;
          case 'FUNCTION':
          case 'SET':
            break;
        }
      }
    } catch(error) {
      console.log(`setDefaultHoverText issue: ${error}`);
    }
  }

  private setDefaultHoverText(spec: LMFormSpec | LMListSpec | LMPageSpec, actionReference: LMBusActionReference, toolbarButton: LMToolbarButton) {
    try {
      switch (actionReference.type) {
        case 'standard':
          // if the button is icon only (doesn't have a label), it needs a tooltip so it shows up correctly in overflow and
          // context menus. If a hover wasn't defined in the LPL, grab the tooltip from the standard toolbar actions.
          Object.keys(this.getStandardToolbarActions())
            .filter((key) => this.getStandardToolbarActions()[ key ].id === actionReference.id)
            .forEach((key) => toolbarButton.actionReference.tooltip = this.getStandardToolbarActions()[ key ].tooltip);
          break;
        case 'action':
          const actionSpecArray: Array<LMActionSpec> = this.getActionSpecs(spec);
          if (!actionSpecArray || actionSpecArray.length === 0) {
            break;
          }
          const actionSpec: LMActionSpec = actionSpecArray[actionReference.index];
          if (!actionSpec || !actionSpec.label) {
            break;
          }
          toolbarButton.actionReference.tooltip = actionSpec.label;
          break;
      }
    } catch (error) {
      console.log(`setDefaultHoverText issue: ${error}`);
    }
  }
}

export interface RelatedActionResponse {
  actionSpec: LMActionSpec;
  dataViewSet: LMDataViewSet;
}

export interface LMToolbarMoreButtonMenuParams {
  isContextMenu: boolean;
  showDrillAround: boolean;
  drillParams?: DrillPointsParams;
  personalizeParams?: PersonalizeParams;
  relatedReportParams?: RelatedReportParams;
  userListViewParams?: UserListViewMenuParams;
}
